import React from "react";
import BannerDevelopment from "../../components/bannerDevelopment";
import EscalabilidadeBusiness from "../../components/escalabilidadeBusiness";
import NossosServicos from "../../components/nossosServicos";
import Diferenciais from "../../components/diferenciais";
import Certificados from "../../components/certificados";
import Rodape from "../../components/rodape";

export default function BusinessAgility() {
    return (
        <>
            <BannerDevelopment
                title="/Business Agility"
                backgroundUrl="../assets/banner-business-agility.png"
                imageMobile="../assets/banner-business-agility-mobile.png"
                description={
                    <>
                        A chave para garantir{" "}
                        <span className="font-inter-bold">entregas</span>{" "}
                        personalizadas, rápidas, flexíveis e eficientes em um
                        <span className="font-inter-bold">
                            {" "}
                            cenário dinâmico.
                        </span>
                    </>
                }
                bottomText={
                    <>
                        VERTICAL PROJECTS |{" "}
                        <span className="font-bold">be.</span>
                        hub
                    </>
                }
                bottomTextMobile="VERTICAL PROJECTS"
                brand="behub"
            />
            <EscalabilidadeBusiness />
            <Diferenciais
                servicosData={[
                    {
                        icon: "",
                        iconHover: "",
                        title: "RESEARCH",
                        text: (
                            <>
                                Analisamos os melhores modelos e cases de
                                sucesso, identificamos os principais players e
                                exploramos as possibilidades futuras para
                                alavancar seu negócio.
                            </>
                        ),
                        glowColor: "#A800E4",
                        url: "",
                        number: "1",
                    },
                    {
                        icon: "",
                        iconHover: "",
                        title: "LAB",
                        text: (
                            <>
                                Elaboramos e testamos cenários e hipóteses
                                estratégicas para definir o modelo ideal e
                                compreender o comportamento do usuário.
                            </>
                        ),
                        glowColor: "#A800E4",
                        url: "",
                        number: "2",
                    },
                    {
                        icon: "",
                        iconHover: "",
                        title: "PILOT",
                        text: (
                            <>
                                Nós planejamos, implementamos, capacitamos e
                                usamos o feedback contínuo para aprimorar a
                                experiência do cliente.
                            </>
                        ),
                        glowColor: "#A800E4",
                        url: "",
                        number: "3",
                    },
                    {
                        icon: "",
                        iconHover: "",
                        title: "SCALE",
                        text: (
                            <>
                                Compreendemos o contexto, planejamos os recursos
                                e cronogramas, implementamos a solução e usamos
                                o feedback contínuo para aprimorar a experiência
                                do cliente.
                            </>
                        ),
                        glowColor: "#A800E4",
                        url: "",
                        number: "4",
                    },
                ]}
                title="Nossa metodologia"
            />
            <NossosServicos
                servicos={[
                    {
                        id: 4,
                        title: "ATO",
                        image: "../assets/servicos/ato_icon.svg",
                        link: "/ato",
                    },
                    {
                        id: 1,
                        title: "PMO",
                        image: "../assets/servicos/pmo_icon.svg",
                        link: "/pmo",
                    },
                    {
                        id: 2,
                        title: "Gestão de Mudanças",
                        image: "../assets/servicos/gestao_de_mudanca_icon.svg",
                        link: "/gestao-de-mudancas",
                    },
                    {
                        id: 3,
                        title: "Gestão de Portfólio",
                        image: "../assets/servicos/gestao_de_portfolio_icon.svg",
                        link: "/gestao-de-portfolio",
                    },
                ]}
                description="
                        Metodologias e soluções ágeis que geram crescimento e
                        eficiência para seu projeto evoluir sempre na direção
                        certa."
                bannerImage="../assets/banner-nossos-servicos-agility.png"
                bgColor="from-[#4B3BDB] via-[#A002CB] to-[#FC0021]"
            />
            <Certificados text="Nossa excelência é certificada por diversas plataformas:" />
            <Rodape />
        </>
    );
}
